import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { filterByDate, filterByDistance } from 'tennders-stracture/libs/map'
import { apiPost } from 'tennders-stracture/libs/api'
import { dispatchMatchTruck } from 'tennders-common/stores/prompt/action'

const useMatchTrucks = () => {
  const dispatch = useDispatch()
  const [range, setrange] = useState(5000)
  const [dateRange, setdateRange] = useState(-1)
  const [trucks, settrucks] = useState([])
  const [loading, setloading] = useState(false)
  const [allItems, setallItems] = useState([])
  const { transaction } = useSelector((state) => state.prompt.truckToMatch)
  const matchTruck = (transaction) => dispatch(dispatchMatchTruck(transaction))

  const filter = (unfilteredItems) => {
    let items = filterByDistance(transaction?.pickupRoute?.location, [...unfilteredItems], range)
    if (dateRange !== false && `${dateRange}` !== '-1' && dateRange !== 'all') {
      items = filterByDate(transaction?.dayDiff, [...items])
    }

    settrucks(items)
  }

  const fetchTrucks = async (transactionId) => {
    setloading(true)
    const response = await apiPost('trucks/to-match', { transaction: transactionId })
    if (response?.items) {
      setallItems(response?.items)
      filter([...response?.items])
    }
    setloading(false)
  }

  useEffect(() => {
    filter(allItems)
  }, [range, dateRange])

  return {
    range,
    setrange,
    dateRange,
    setdateRange,
    trucks,
    loading,
    matchTruck,
    fetchTrucks,
    truckToMatch: transaction
  }
}

export default useMatchTrucks
